enum DragType {
  CHALLENGE = 'CHALLENGE',
  TASK = 'TASK',
}

export default DragType;
